import React from "react";
import s from "./style.module.css";
import Modal from "../Modal";
import { info } from "../../content/copy";

const WhatIsModal = () => {
  const { cta, copy } = info;
  return (
    <Modal
      openText={
        <span className={s.cta}>
          {process.env.REACT_APP_STYLE !== "ac" && (
            <svg
              className={s.icon}
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 .941A7.059 7.059 0 108 15.06 7.059 7.059 0 008 .94zM7.658 5.48c.414 0 .756.31.806.71l.007.103v4.449c0 .098.066.181.157.206l.056.008h1.027a.47.47 0 01.085.933l-.085.008H8.684c-.598 0-1.09-.455-1.149-1.037l-.006-.118V6.419h-.898a.47.47 0 01-.463-.385l-.008-.085a.47.47 0 01.386-.463l.085-.007h1.027zm.167-1.715l.063.004.015.001.017.002.035.006a.5.5 0 01.043.01l-.078-.016a.642.642 0 11-.19 0l.095-.007z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          )}

          {process.env.REACT_APP_STYLE === "ac" && (
            <svg
              className={s.icon}
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.40991 4.68994H9.58991V5.93994H8.40991V4.68994ZM9.53991 13.3099H8.45991V6.99994H9.53991V13.3099Z"
                fill="#3138BB"
              />
              <path
                d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
                stroke="#3138BB"
                stroke-miterlimit="10"
              />
            </svg>
          )}

          {cta}
        </span>
      }
    >
      <h2 className={s.title}>{cta}</h2>

      {copy.map(({ value }, i) => (
        <p
          className={s.p}
          key={i}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      ))}
    </Modal>
  );
};

export default WhatIsModal;
